import axiosInstance from "./axiosInstance";

export const getAdminLogs = async (params = {}) => {
  try {
    const config = {
      params,
      headers: {
        "Cache-Control": "no-cache",
        Pragma: "no-cache",
      },
    };

    const response = await axiosInstance.get("/admin-logs", config);
    return response.data;
  } catch (error) {
    console.error("Error fetching admin logs:", error);
    throw error;
  }
};

export const getLogStats = async (params = {}) => {
  try {
    const config = {
      params,
      headers: {
        "Cache-Control": "no-cache",
        Pragma: "no-cache",
      },
    };

    const response = await axiosInstance.get("/admin-logs/stats", config);
    return response.data;
  } catch (error) {
    console.error("Error fetching log stats:", error);
    throw error;
  }
};

export const exportLogs = async (params = {}) => {
  try {
    const response = await axiosInstance.get("/admin-logs", {
      params: { ...params, format: "csv" },
      responseType: "blob",
    });
    return response.data;
  } catch (error) {
    console.error("Error exporting logs:", error);
    throw error;
  }
};
